import { nowIso } from '../domain/time.js';
import { revokeUnlistedUsers, setLocalRetentionDays } from '../privacy.js';
import { setOfflineLockDays } from '../auth/contact.js';
export async function applySyncPullPage(db, page) {
    const p = page.property;
    if (p.id !== db.context.propertyId) {
        throw new Error(`Pull response is for property ${p.id} but this device is bound to ${db.context.propertyId}`);
    }
    const now = nowIso();
    await db.driver.batch([
        { sql: 'DELETE FROM property' },
        {
            sql: `INSERT INTO property
              (id, name, legal_name, address, city, pincode, phone, email, gstin, state_code,
               fssai, currency, timezone, settings_json, updated_at,
               packaging_takeaway_paise, packaging_delivery_paise, delivery_fee_paise, service_charge_pct_bp)
            VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
            params: [
                p.id,
                p.name,
                p.legalName ?? null,
                p.address ?? null,
                p.city ?? null,
                p.pincode ?? null,
                p.phone ?? null,
                p.email ?? null,
                p.gstin,
                p.stateCode,
                p.fssai ?? null,
                p.currency ?? 'INR',
                p.timezone ?? 'Asia/Kolkata',
                '{}',
                now,
                page.charges.packagingTakeawayPaise,
                page.charges.packagingDeliveryPaise,
                page.charges.deliveryFeePaise,
                page.charges.serviceChargePctBp,
            ],
        },
        // Portable update-then-insert pairs (minSdk 26 SQLite has no upsert).
        ...page.users.flatMap((u) => [
            {
                // The server no longer sends emails (DPDP minimisation); an empty one
                // leaves whatever this till already had - the enrolled user's own,
                // from provisioning - rather than blanking it.
                sql: `UPDATE users SET name = ?, email = CASE WHEN ? = '' THEN email ELSE ? END, is_active = ?, role = ?
              WHERE id = ?`,
                params: [u.name, u.email, u.email, u.isActive ? 1 : 0, u.role, u.id],
            },
            {
                sql: `INSERT INTO users (id, name, email, is_active, role)
              SELECT ?, ?, ?, ?, ? WHERE (SELECT changes()) = 0`,
                params: [u.id, u.name, u.email, u.isActive ? 1 : 0, u.role],
            },
        ]),
        { sql: 'DELETE FROM entitlement' },
        {
            sql: `INSERT INTO entitlement (id, is_entitled, plan_name, grace_until, as_of)
            VALUES (1, ?, NULL, NULL, ?)`,
            params: [page.entitlement.isEntitled ? 1 : 0, page.entitlement.asOf],
        },
    ]);
    // Separate calls (not part of the batch above): each repo method owns its
    // own statement shape and is exercised independently by Phase 2/3 tests.
    // A crash between these and the block above is safe to replay - every
    // write here is either a full single-row replace or an idempotent UPSERT.
    await db.catalog.upsertCategories(page.categories);
    await db.tables.upsertTables(page.restaurantTables);
    await db.catalog.upsertMenuItems(page.menuItems);
    await db.offers.replaceAll(page.offers);
    if (page.localRetentionDays)
        await setLocalRetentionDays(db, page.localRetentionDays);
    if (page.offlineLockDays)
        await setOfflineLockDays(db.config, page.offlineLockDays);
    const revokedUserIds = page.usersComplete
        ? await revokeUnlistedUsers(db, page.users.map((user) => user.id))
        : [];
    return { revokedUserIds };
}
//# sourceMappingURL=pull.js.map